import { render, staticRenderFns } from "./Thesis24.vue?vue&type=template&id=79a20747&scoped=true&"
import script from "./Thesis24.vue?vue&type=script&lang=js&"
export * from "./Thesis24.vue?vue&type=script&lang=js&"
import style0 from "./Thesis24.vue?vue&type=style&index=0&id=79a20747&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a20747",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
